import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import NotFound from "pages/NotFound";
import ContentManagement from './pages/content-management';
import AdminDashboard from './pages/admin-dashboard';
import HomeGallery from './pages/home-gallery';
import CategoryGallery from './pages/category-gallery';
import AdminLogin from './pages/admin-login';
import HallOfFame from './pages/hall-of-fame';
import CategoryManagement from './pages/category-management';
import HallOfFameEditor from './pages/hall-of-fame-editor';
import AdminUsers from './pages/admin-users';
import AdminSettings from './pages/admin-settings';
import ShoppingCart from './pages/shopping-cart';
import PlansManagement from './pages/plans-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<HomeGallery />} />
            <Route path="/content-management" element={<ContentManagement />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/home-gallery" element={<HomeGallery />} />
            <Route path="/category-gallery" element={<CategoryGallery />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/hall-of-fame" element={<HallOfFame />} />
            <Route path="/category-management" element={<CategoryManagement />} />
            <Route path="/hall-of-fame-editor" element={<HallOfFameEditor />} />
            <Route path="/admin-users" element={<AdminUsers />} />
            <Route path="/admin-settings" element={<AdminSettings />} />
            <Route path="/shopping-cart" element={<ShoppingCart />} />
            <Route path="/plans-management" element={<PlansManagement />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
